var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#E8EDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4636_42603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8438 34.6829H41.7614L37.5149 30.3887C35.6465 32.7431 33.0674 34.3556 31.8438 34.6829Z",
    fill: "url(#paint0_linear_4636_42603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 31.3184V34.6834H30.3927C29.4575 34.433 27.3026 33.2423 25.5 31.3184Z",
    fill: "url(#paint1_linear_4636_42603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7894 32.8444C31.003 32.924 31.2379 32.9232 31.4512 32.8418C31.5328 32.8107 33.4719 32.0548 35.3927 29.9831C37.1439 28.0945 39.2313 24.6949 39.2313 19.225C39.2313 18.6995 38.7991 18.2765 38.2736 18.2877C35.9148 18.3383 33.5715 17.5916 31.6767 16.1848C31.3448 15.9384 30.8908 15.9384 30.5589 16.1848C28.6597 17.5949 26.3149 18.3441 23.9576 18.2928C23.4406 18.2793 23 18.6988 23 19.2302C23 24.7318 25.0889 28.1287 26.8412 30.0096C28.7649 32.0743 30.7076 32.8139 30.7894 32.8444ZM28.7027 23.337C29.0688 22.9709 29.6624 22.9709 30.0286 23.337L30.6469 23.9553L32.7028 21.8995C33.0689 21.5334 33.6625 21.5334 34.0286 21.8995C34.3948 22.2657 34.3948 22.8592 34.0286 23.2253L31.3099 25.9441C30.9438 26.3103 30.3501 26.3102 29.9841 25.9441L28.7028 24.6628C28.3366 24.2967 28.3366 23.7032 28.7027 23.337Z",
    fill: "url(#paint2_linear_4636_42603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6034 42.2305C22.0128 42.2305 20.7188 43.5245 20.7188 45.115C20.7188 46.7056 22.0128 47.9997 23.6034 47.9997C25.1939 47.9997 26.488 46.7057 26.488 45.1151C26.488 43.5245 25.194 42.2305 23.6034 42.2305Z",
    fill: "url(#paint3_linear_4636_42603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9375 40.2871C44.4198 40.2871 44 39.8673 44 39.3496C44 38.8318 44.4198 38.4121 44.9375 38.4121H47.9094C47.7391 37.679 47.3356 37.0306 46.7652 36.5579H24.5625C24.0448 36.5579 23.625 36.1381 23.625 35.6204V29.0625H22.6681C22.3152 29.0625 21.9922 29.2607 21.8323 29.5754L19.2373 34.6829H18.1875C16.9813 34.6829 16 35.6642 16 36.8704V38.5H18.875C19.3928 38.5 19.8125 38.9197 19.8125 39.4375C19.8125 39.9552 19.3928 40.375 18.875 40.375H16V40.5769C16 42.3182 17.3019 43.7604 18.9832 43.9834C19.4926 41.9038 21.3714 40.3557 23.6058 40.3557C25.8512 40.3557 27.7372 41.9192 28.2354 44.0144H35.8223C36.3205 41.9192 38.2065 40.3557 40.4519 40.3557C42.6974 40.3557 44.5834 41.9192 45.0816 44.0144H47.0625C47.5802 44.0144 48 43.5946 48 43.0769V40.287H44.9375V40.2871Z",
    fill: "url(#paint4_linear_4636_42603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4549 42.2305C38.8644 42.2305 37.5703 43.5245 37.5703 45.115C37.5703 46.7056 38.8644 47.9997 40.4549 47.9997C42.0455 47.9997 43.3396 46.7057 43.3396 45.1151C43.3396 43.5245 42.0455 42.2305 40.4549 42.2305Z",
    fill: "url(#paint5_linear_4636_42603)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4636_42603",
    x1: 31.8437,
    y1: 30.3887,
    x2: 40.4832,
    y2: 36.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4636_42603",
    x1: 25.5,
    y1: 31.3184,
    x2: 30.8342,
    y2: 33.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4636_42603",
    x1: 23,
    y1: 16,
    x2: 42.5129,
    y2: 21.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4636_42603",
    x1: 20.7187,
    y1: 42.2305,
    x2: 27.6081,
    y2: 44.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4636_42603",
    x1: 16,
    y1: 29.0625,
    x2: 45.2514,
    y2: 48.2127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4636_42603",
    x1: 37.5703,
    y1: 42.2305,
    x2: 44.4597,
    y2: 44.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4636_42603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboard);
export default __webpack_public_path__ + "static/media/onboard.20979553375d0e74a87b70f0c1c42452.svg";
export { ForwardRef as ReactComponent };